const csrInitState = {
    csrData: {},
    klinikWaqafData: {},
    covid19BookletData: {}
};

export default csrInitState;
